// extracted by mini-css-extract-plugin
module.exports = {"desktopContainer":"Header_desktopContainer__3pkyB","mobileContainer":"Header_mobileContainer__3-3O4"};